import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
export var EventEmitter = /*#__PURE__*/function () {
  function EventEmitter() {
    _classCallCheck(this, EventEmitter);

    _defineProperty(this, "listeners", Array.of());
  }

  _createClass(EventEmitter, [{
    key: "subscribe",
    value: function subscribe(listener) {
      var _this = this;

      this.listeners.push(listener);
      return function () {
        return _this.unsubscribe(listener);
      };
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(listener) {
      this.listeners = this.listeners.filter(function (l) {
        return l !== listener;
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.listeners = [];
    }
  }, {
    key: "emit",
    value: function emit(data) {
      this.listeners.forEach(function (listener) {
        return listener(data);
      });
    }
  }]);

  return EventEmitter;
}();